import { render, staticRenderFns } from "./ServiceWorkers.vue?vue&type=template&id=4dac275d&scoped=true"
import script from "./ServiceWorkers.vue?vue&type=script&lang=ts"
export * from "./ServiceWorkers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dac275d",
  null
  
)

export default component.exports